<style lang="scss">
.btn-success {
  cursor: pointer;
}
.items-cuenta {
  .item-name {
    font-weight: bold;
  }

  .item-type,
  .item-cbu {
    font-size: 13px;
  }
}
.lbl-title {
  color: red;
  font-weight: bold;
  font-size: 20px;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Mis Cuentas</b-card-header>
      <b-card-body v-if="AcceptTermsAndConditions">
        <div class="col-md-12 text-center lbl-title">{{title}}</div>
        <div class="col-md-12 text-center" style="padding-bottom:30px;font-size:13px">{{subtitle}}</div>
        <div v-if="accountsLength == 0" class="text-center">
          <img src="/img/nobank_gray.png" />
        </div>
        <div
          v-if="accountsLength > 0"
          style="overflow-y:scroll;max-height: 250px;overflow-y: auto;"
        >
          <div
            class="row"
            v-for="item in accounts"
            v-bind:key="item.Id"
            style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
          >
            <div class="col-2" @click="GoToAddMoney(item.EntityID)">
              <img :src="item.Image" class="circle-img" style="width: 50px" alt />
            </div>
            <div class="col-6 items-cuenta" @click="GoToAddMoney(item.EntityID)">
              <div class="row item-name">{{item.AccountName}}</div>
              <div class="row item-type">{{item.Type}}</div>
              <div class="row item-cbu">CBU: {{item.CVU_CBU}}</div>
            </div>
            <div class="col-3 text-right mt-4">
              <a
                href="#"
                @click="GoToAddMoney(item.EntityID)"
                v-b-tooltip.hover
                title="Ingresar dinero"
              >
                <span class="btn-inner--icon">
                  <img src="img/icons/android-icon-36x36.png" />
                </span>
              </a>
              <a
                href="#"
                @click="GoToAdminAccount(item.EntityID)"
                style="padding-left:10px"
                v-b-tooltip.hover
                title="Modificar cuenta"
              >
                <span class="btn-inner--icon">
                  <img src="img/icons/Edit.png" />
                </span>
              </a>
              <a
                href="#"
                @click="GoToDeleteAccountsPsp(item.PSPID)"
                style="padding-left:10px"
                v-b-tooltip.hover
                title="Eliminar cuenta"
              >
                <span class="btn-inner--icon">
                  <img src="img/icons/Trash.png" />
                </span>
              </a>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center">
          <div style="display: inline-block;">
            <img src="/img/add_university.png" style="width: 90px;" />
          </div>
          <div style="display: inline-block;padding-left:40px;padding-right:40px;padding-top:40px">
            <div class="lbl-title">¿Querés agregar una nueva cuenta?</div>
            <div>Seleccioná tu proveedor de cuenta</div>
          </div>
          <div style="display: inline-block;">
            <base-button
              type="success"
              size="lg"
              @click="GotToAddAccount"
              style="margin: auto; margin-top: 10px"
            >
              <i class="fa fa-plus fa-fw"></i>Nueva
            </base-button>
          </div>
        </div>
      </b-card-body>

      <b-card-body v-if="AcceptTermsAndConditions == false">
        <div class="col-md-6 text-center" style="display: inline-block;">
          <div class="text-center lbl-title">Ingresá dinero a tu cuenta!</div>
          <img src="/img/mis-cuentas-img.png" />
        </div>
        <div class="col-md-5" style="display: inline-block;">
          <div class="text-center" style="font-weight:bold;font-size:20px;">
            Tu dinero en un sólo lugar!
            <a
              @click="GoToInfo()"
              style="padding: 2px; cursor: pointer;"
            >
              <img src="/img/Informacion.8f90e30c.png" style="width: 20px;height:20px" />
            </a>
          </div>
          <div class="text-center" style="font-weight:bold">Seguro, al instante y sin tarjetas.</div>
          <hr />
          <ul class="a">
            <li>Seleccioná y asociá tu proveedor de cuenta por única vez.</li>
            <li>Ingresá el monto que querés cargar.</li>
            <li>Recibí el dinero en tu cuenta Resimple.</li>
          </ul>
        </div>
        <div class="col-md-12 text-center" style="margin-top: 20px">
          <b-button
            class="btn btn-danger"
            @click="TransferMoneyClick()"
            :disabled="!AcceptTermsAndConditionsCheckValue"
          >Ingresar Dinero</b-button>
          <div class="resimple-switch" style="margin-top: 20px">
            <label class="switch">
              <input type="checkbox" v-model="AcceptTermsAndConditionsCheckValue" />
              <span class="slider round" />
              <a
                href="https://www.resimple.com.ar/legales/"
                target="_blank"
              > Acepto términos y condiciones</a>
            </label>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import axiosHelpers from "@/helpers/axiosHelpers";
import generalHelpers from "@/helpers/generalHelpers";

export default {
  components: {},
  data() {
    return {
      accounts: [],
      accountsLength: 0,
      AcceptTermsAndConditions: false,
      AcceptTermsAndConditionsCheckValue: false,
      title: "",
      subtitle: ""
    };
  },
  methods: {
    InitializeTitle() {
      let context = this;

      if (context.accountsLength == 0) {
        context.title = "No tenés cuentas agendadas!";
        context.subtitle = "No existen proveedores de cuentas asociados";
      } else {
        context.title = "¿Desde qué cuenta querés ingresar dinero?";
        context.subtitle = "Tus cuentas agendadas";
      }
    },
    TransferMoneyClick() {
      let context = this;
      context.AcceptTermsAndConditions =
        context.AcceptTermsAndConditionsCheckValue;
      context.GetAccounts();
    },
    Click(item) {},
    GetAccounts() {
      let context = this;
      axiosHelpers.axiosGet(
        "RecruitmentAccountsPsp/GetAccountsPsp",
        {},
        context,
        function(data) {
          context.accounts = data.ResponseVM.Items;
          context.accountsLength = data.ResponseVM.Items.length;

          context.InitializeTitle();
        }
      );
    },
    GoToInfo() {},
    GoToAddMoney(Id) {
      let context = this;
      context.$router.push({
        name: "IngresarDinero",
        params: { AccountPSPIDProp: Id }
      });
    },
    GoToAdminAccount(Id) {
      let context = this;
      context.$router.push({
        name: "AdministrarCuenta",
        params: { EntityIDProp: Id }
      });
    },
    GoToDeleteAccountsPsp(PSPID) {
      let context = this;

      context.$router.push({
        name: "EliminarPSP",
        params: { PspIDProp: PSPID }
      });
    },
    GotToAddAccount() {
      let context = this;
      context.$router.push({ name: "AgregarCuenta" });
    }
  },
  beforeMount: function() {
    let context = this;
    if (context.AcceptTermsAndConditions) {
      context.GetAccounts();
    }
  }
};
</script>